<template>
  <div id="nav-template" class="sticky-top">
    <nav>
        <div class="brand-text">
            <router-link :to="{ path: '/'}">
                Treasure-X
                <span class="version-tag">Alpha.v0.1 - Nebulas</span>
            </router-link>
        </div>
        
        <span class="brand-subtext">
            "Blockchain Pirates unite to bury and find Crypto Treasure!"
        </span>

        <div v-if="pendingTransaction" class="transaction-loader">
            <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
            <sub>{{ 'PENDING_TRANSACTION' | translate }}</sub>
        </div>

        <!--
        <b-button-group class="translation-btn" size="sm">
            <b-button :class="{ selected: locale == 'en' }" @click="updateLocale('en')">EN</b-button>
            <b-button :class="{ selected: locale == 'cn' }" @click="updateLocale('cn')">CN</b-button>
        </b-button-group>     
        -->
    </nav>
    <div v-if="hasError.status" class="alert alert-warning" role="alert">
        <div v-html="$t('NEBULAS_ERROR')"></div>
        <div>
            {{ 'ERROR_MESSAGE' | translate }}: {{ hasError.message }}
        </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex";
import { getCardScore } from "../../util/transformDna";

export default {
    name: 'the-top-nav',
    methods: {
        viewCard (card) {
            this.$root.$emit('bv::show::modal','card-view-modal');
            this.$store.commit('setCard', card);
        },
        constructCardFromDna (card) {
            let power = {};
            return power;
        },
        getCardScore (card) {
            return getCardScore(card);
        },
        saveAddress () {
            this.$store.commit('setUser', { address: this.address });
            this.$store.commit('updateUserCards', { address: this.address });
        },
        resetAddress () {
            this.$store.commit('resetUser');
            this.$store.commit('resetUserCards');
        },
        updateLocale (locale) {
            
            this.$store.commit('setLocale', { locale });
            
            // Set in module
            this.$i18n.set(locale);

        }
    },
    data () {
        return {
            address: null
        }
    },
    computed: {
        ...mapGetters({
            locale: 'getLocale',
            hasError: 'getHasError',
            hasExtension: 'getHasExtension',
            pendingTransaction: 'getPendingTransaction'
        })
    }
}
</script>

<style scoped lang="less">
@backgroundColor: #3c3f44;
@navFontFamily: 'Cabin Sketch', cursive;

.alert {
    text-align: center;
    margin-bottom: 0;
    border-radius: 0;
}

nav {
    .transaction-loader {
        position: absolute;
        top: 55px; left: 26px;

        sub {
            font-size: 13px;
            color: #ccc;
        }
    }

    .translation-btn {
        position: absolute;
        top: 20px; right: 20px;
    }

    .form-control {
        border-radius: 0;
    }

    .address-header {
        width: 400px;
        position: relative;
        overflow: hidden;
        text-align: center;
        text-overflow: ellipsis;

        i {
            position: absolute;
            top: 8px;
            right: 10px;
        }
    }

    .brand-text {
        font-size: 36px;
        font-family: @navFontFamily;

        a {
            position: relative;
            color: #fff;

            &:hover {
                text-decoration: none;
            }
        }

        .version-tag {
            position: absolute;
            right: 0; top: -20px;
            font-size: 12px;
            color: #88929b;
        }
    }

    .brand-subtext {
        font-style: italic;
        font-size: 13px;
    }

    .card-counter {
        position: absolute;
        top: 25px;
        left: 30px;
        color: #ccc;
        font-size: 13px;
    }

    .version-text {
        position: absolute;
        top: 15px; right: 30px;
    }
}

// Tablet device
@media only screen and (max-width: 768px) {
    .card-counter, .transaction-loader {
        display: none;
    }
    .dropdown, .translation-button {
        display: none;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/TheTopNav.vue